
console.log('product-price-list');

// Enhanced solution for pagination and scroll tracking
(function() {
  'use strict';

  class CountdownTimer {
    constructor() {
      this.timers = new Map();
      this.init();
    }

    init() {
      this.initializeTimers();
    }

    initializeTimers() {
      const containers = document.querySelectorAll('.category-status-container');

      containers.forEach((container, index) => {
        const timer = container.querySelector('.timer-layout-minutes');

        if (timer) {
          this.startCountdown(container, `timer-${index}`, timer);
        }
      });
    }

    startCountdown(container, timerId, timer) {
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      if (!this.isValidNumber(timerPartOneSpan.textContent)) {
        return;
      }

      let currentValue = this.parseNumber(timerPartOneSpan.textContent);

      const intervalId = setInterval(() => {
        currentValue--;

        timerPartOneSpan.textContent = this.formatDisplayValue(currentValue);

        if (currentValue <= 0) {
          this.handleTimerEnd(intervalId, timerId, container, timer);
        }
      }, 58000);

      this.timers.set(timerId, { intervalId, container, timerPartOneSpan });
    }

    handleTimerEnd(intervalId, timerId, container, timer) {
      const timerPartTwo = timer?.querySelector('.timer-part-02');
      const timerPartOneSpan = timer?.querySelector('.timer-part-01 span');

      clearInterval(intervalId);
      this.timers.delete(timerId);

      timerPartOneSpan.textContent = '00';
      timerPartOneSpan.classList.add('timer-ended');

      timerPartTwo.innerHTML = '<div class="counter-number"><span>00</span></div>';

      setTimeout(() => {
        container.innerHTML = '<div class="status-badge ended">Ended</div>';
      }, 500); // 0.5s delay
    }

    formatDisplayValue(value) {
      if (value < 10 && value >= 0) {
        return `0${value}`;
      }
      return value.toString();
    }

    parseNumber(text) {
      return parseInt(text.trim(), 10);
    }

    isValidNumber(text) {
      const num = this.parseNumber(text);
      return !isNaN(num) && num > 0;
    }

    destroy() {
      this.timers.forEach(({ intervalId }, timerId) => {
        clearInterval(intervalId);
        this.timers.delete(timerId);
      });
    }

    reinitialize() {
      this.destroy();
      this.initializeTimers();
    }
  }

  // Initialize timer when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    window.countdownTimer = new CountdownTimer();
  });

  // For Shopify theme editor compatibility
  if (typeof Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', () => {
      if (window.countdownTimer) {
        window.countdownTimer.reinitialize();
      }
    });

    document.addEventListener('shopify:section:unload', () => {
      if (window.countdownTimer) {
        window.countdownTimer.destroy();
      }
    });
  }


  // ===== ENHANCED LOGIN LINK FUNCTIONALITY =====
  function initEnhancedLoginLinks() {
      const loginLinks = document.querySelectorAll('.member-price-login-link');

      loginLinks.forEach(link => {
          const baseUrl = link.getAttribute('data-base-url');
          const intent = link.getAttribute('data-intent');

          // Function to update link with current state
          const updateLinkWithCurrentState = function() {
              const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
              const scrollX = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
              
              // Get current URL without hash and any existing scroll parameters
              let currentUrl = window.location.pathname + window.location.search;
              
              // Remove existing scroll parameters if any
              currentUrl = currentUrl.replace(/[?&]scroll_x=\d+&scroll_y=\d+/g, '');
              currentUrl = currentUrl.replace(/[?&]scroll_y=\d+&scroll_x=\d+/g, '');
              currentUrl = currentUrl.replace(/[?&]scroll_[xy]=\d+/g, '');
              
              // Build return URL with scroll parameters
              let returnUrl = currentUrl;
              const separator = returnUrl.includes('?') ? '&' : '?';
              returnUrl += `${separator}scroll_x=${scrollX}&scroll_y=${scrollY}`;

              // Build final login URL
              const newHref = `${baseUrl}?return_url=${encodeURIComponent(returnUrl)}&intent=${intent}`;

              // Update the link
              link.setAttribute('href', newHref);
              link.href = newHref;

              // Store in sessionStorage as backup
              try {
                  sessionStorage.setItem('login_scroll_backup', JSON.stringify({
                      x: scrollX,
                      y: scrollY,
                      url: currentUrl,
                      timestamp: Date.now()
                  }));
              } catch (e) {
                  console.log('Session storage not available');
              }

              return newHref;
          };

          // Initial update
          updateLinkWithCurrentState();

          // Update on various events
          const events = ['mouseenter', 'focus', 'touchstart', 'mousedown'];
          events.forEach(event => {
              link.addEventListener(event, function(e) {
                  if (event === 'mousedown' && e.button === 2) {
                      updateLinkWithCurrentState();
                      return;
                  }
                  updateLinkWithCurrentState();
              });
          });

          // Handle context menu
          link.addEventListener('contextmenu', function(e) {
              updateLinkWithCurrentState();
          });

          // Handle actual click
          link.addEventListener('click', function(e) {
              updateLinkWithCurrentState();
          });
      });
  }

  // ===== PAGINATION DETECTION AND HANDLING =====
  function initPaginationHandler() {
      // Observe for URL changes (for pagination)
      let currentURL = window.location.href;
      
      // Function to check if URL changed (for pagination)
      function checkURLChange() {
          if (window.location.href !== currentURL) {
              currentURL = window.location.href;
              // URL changed, reinitialize login links
              setTimeout(() => {
                  initEnhancedLoginLinks();
                  // Also update scroll restoration data
                  updateScrollBackup();
              }, 100);
          }
      }

      // Check for URL changes periodically
      setInterval(checkURLChange, 500);

      // Also listen for popstate (browser back/forward)
      window.addEventListener('popstate', function() {
          setTimeout(() => {
              initEnhancedLoginLinks();
              updateScrollBackup();
          }, 100);
      });

      // Listen for Shopify's AJAX completion events
      document.addEventListener('shopify:section:load', function() {
          setTimeout(() => {
              initEnhancedLoginLinks();
              updateScrollBackup();
          }, 150);
      });

      // MutationObserver for DOM changes (pagination content load)
      const observer = new MutationObserver(function(mutations) {
          let shouldUpdate = false;
          mutations.forEach(function(mutation) {
              if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  mutation.addedNodes.forEach(function(node) {
                      if (node.nodeType === 1) { // Element node
                          if (node.classList && (
                              node.classList.contains('product-grid') ||
                              node.classList.contains('collection') ||
                              node.querySelector('.product-card') ||
                              node.querySelector('.pagination')
                          )) {
                              shouldUpdate = true;
                          }
                      }
                  });
              }
          });
          
          if (shouldUpdate) {
              setTimeout(() => {
                  initEnhancedLoginLinks();
                  updateScrollBackup();
              }, 200);
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  }

  // Update scroll backup data
  function updateScrollBackup() {
      try {
          const scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          const scrollX = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
          const currentUrl = window.location.pathname + window.location.search;
          
          sessionStorage.setItem('login_scroll_backup', JSON.stringify({
              x: scrollX,
              y: scrollY,
              url: currentUrl,
              timestamp: Date.now()
          }));
      } catch (e) {
          // Session storage not available
      }
  }

  // ===== SCROLL RESTORATION FUNCTIONALITY =====
  function shouldSkipScrollRestoration() {
      const currentPath = window.location.pathname;
      const skipPages = [
          '/account/login',
          '/account/register',
          '/account',
          '/cart',
          '/checkout'
      ];
      return skipPages.some(page => currentPath.includes(page));
  }

  function cleanURL() {
      try {
          const urlParams = new URLSearchParams(window.location.search);
          if (urlParams.has('scroll_x') || urlParams.has('scroll_y')) {
              urlParams.delete('scroll_x');
              urlParams.delete('scroll_y');
              const newSearch = urlParams.toString();
              const newURL = newSearch ?
                  `${window.location.pathname}?${newSearch}` :
                  window.location.pathname;
              window.history.replaceState({}, document.title, newURL);
          }
      } catch (error) {
          console.error('URL cleaning error:', error);
      }
  }

  function restoreScrollPosition() {
      if (shouldSkipScrollRestoration()) {
          return;
      }

      try {
          const urlParams = new URLSearchParams(window.location.search);
          const scrollX = urlParams.get('scroll_x');
          const scrollY = urlParams.get('scroll_y');

          let backupScrollData = null;
          try {
              const stored = sessionStorage.getItem('login_scroll_backup');
              if (stored) {
                  backupScrollData = JSON.parse(stored);
              }
          } catch (e) {}

          let targetX = 0;
          let targetY = 0;
          let hasScrollData = false;

          if (scrollX && scrollY) {
              targetX = parseInt(scrollX);
              targetY = parseInt(scrollY);
              hasScrollData = true;
          } else if (backupScrollData) {
              targetX = backupScrollData.x || 0;
              targetY = backupScrollData.y || 0;
              hasScrollData = true;
          }

          if (hasScrollData) {
              let attemptCount = 0;
              const maxAttempts = 5;

              const attemptScroll = function() {
                  attemptCount++;

                  if (window.scrollTo) {
                      window.scrollTo(targetX, targetY);
                  }

                  if (document.documentElement) {
                      document.documentElement.scrollLeft = targetX;
                      document.documentElement.scrollTop = targetY;
                  }

                  if (document.body) {
                      document.body.scrollLeft = targetX;
                      document.body.scrollTop = targetY;
                  }

                  const currentY = window.pageYOffset ||
                      document.documentElement.scrollTop ||
                      document.body.scrollTop ||
                      0;

                  const currentX = window.pageXOffset ||
                      document.documentElement.scrollLeft ||
                      document.body.scrollLeft ||
                      0;

                  if (attemptCount < maxAttempts && Math.abs(currentY - targetY) > 10) {
                      const nextDelay = 100 * attemptCount;
                      setTimeout(attemptScroll, nextDelay);
                  } else {
                      try {
                          sessionStorage.removeItem('login_scroll_backup');
                      } catch (e) {}

                      if (scrollX && scrollY) {
                          cleanURL();
                      }
                  }
              };

              setTimeout(attemptScroll, 50);
              setTimeout(attemptScroll, 200);
              setTimeout(attemptScroll, 500);
          }
      } catch (error) {
          console.error('Scroll restoration error:', error);
      }
  }

  function initScrollRestoration() {
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
          setTimeout(restoreScrollPosition, 50);
      }

      document.addEventListener('DOMContentLoaded', function() {
          setTimeout(restoreScrollPosition, 100);
      });

      window.addEventListener('load', function() {
          setTimeout(restoreScrollPosition, 200);
      });

      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
          setTimeout(restoreScrollPosition, 300);
          setTimeout(restoreScrollPosition, 600);
      }
  }

  // ===== MAIN INITIALIZATION =====
  function init() {
      // Initialize login links
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
          setTimeout(() => {
              initEnhancedLoginLinks();
              initPaginationHandler();
          }, 100);
      } else {
          document.addEventListener('DOMContentLoaded', function() {
              initEnhancedLoginLinks();
              initPaginationHandler();
          });
      }

      // Initialize scroll restoration
      initScrollRestoration();

      // Also update on window load
      window.addEventListener('load', function() {
          setTimeout(() => {
              initEnhancedLoginLinks();
          }, 300);
      });
  }

  // Start the initialization
  init();

})();